export const CHARACTERS = {
    elem1: {
        name: 'Dawn Warrior',
        job: 'Warrior',
        abilityNames: ['Bluster', 'Cosmos'],
        description: 'Through their blades, Dawn Warriors channel the light of the sun and stars. They win the day with ' +
            'their high Strength and HP.'
    },
    elem2: {
        name: 'Blaze Wizard',
        job: 'Magician',
        abilityNames: ['Flame Vortex', 'Savage Flame'],
        description: 'Like Magicians, Blaze Wizards have high Intelligence and Magic Attack. Bonded with Ignis, the ' +
            'spirit of fire, they can channel his power to summon creatures of flame.'
    },
    elem3: {
        name: 'Wind Archer',
        job: 'Bowman',
        abilityNames: ['Breeze Arrow', 'Howling Gale'],
        description: 'Like Bowmen, Wind Archers shoot from a distance, using their high Dexterity to ensure accuracy. ' +
            'The spirit of wind, Ventus, protects them and enhances their arrows.'
    },
    elem4: {
        name: 'Night Walker',
        job: 'Thief',
        abilityNames: ['Dark Servant', 'Dark Omen'],
        description: 'Night Walkers fight smart from a distance, trusting the outcome to their high Luck. The benevolent' +
            ' Spirit of Darkness protects them in shrouds of shadow, and sends servants to assist them.'
    },
    elem5: {
        name: 'Thunder Breaker',
        job: 'Pirate',
        abilityNames: ['Gale', 'Deep Rising'],
        description: 'Like a Pirate and Brawler in one, a Thunder Breaker uses high Strength to choke the enemy with ' +
            'knuckle sandwiches. More than that, they can call on Fulgar, the Spirit of Lightning, to send crashing ' +
            'waves and beasts of the sea.'
    },
    elem6: {
        name: 'Mihile',
        job: 'Warrior',
        abilityNames: ['Royal Guard', 'Radiant Soul Slash'],
        description: ' From his earliest childhood on a remote mountain farm, Mihile sought to take up the mantle of the' +
            ' famed Knight of Light, a champion of benevolent power. He harnesses the power of light to unleash powerful' +
            ' attacks, and to nullify enemy attacks.'
    },
}

export const SCREENSHOTS = [
    {
        name: 'Selena',
        image: 'first-screenshot.png',
        imageMob: 'first-screenshot-mob.png',
        title: 'DJ Selena\'s Showtime at the Firework Festival:',
        text: 'DJ Selena has arrived to the firework festival and is ready to put on a show! Enjoy a new set of events\n' +
            '              as the Fireworks Festival Parade closes out 2022!'
    },{
        name: 'Home',
        image: 'second-screenshot.png',
        imageMob: 'second-screenshot-mob.png',
        title: 'My Home - Maplemas:',
        text: 'Tis the season to decorate, and there\'s dozens of festive decorations, furniture, buildings, and more ' +
            'to give your Home the holiday look it needs!'
    },{
        name: 'Misty',
        image: 'third-screenshot.png',
        imageMob: 'third-screenshot-mob.png',
        title: 'Misty Island Legacy:',
        text: 'Travel to the remote Misty Island for an adventure filled with a battle for survival, explore the ' +
            'unknown, and uncover the mystery of the Lava Stones!'
    },
]

export const PLACES = [
    {
        name: 'Odium',
        image: 'odium.png',
        imageMob: 'odium-mob.png',
        title: 'Odium, the Awakened Laboratory:',
        text: 'Delve into Odium, a mysterious laboratory hidden in the clouds! \n' +
            'Discover the secrets hidden within, and learn exactly how dangerous these locked doors can be to open...'
    },
    {
        name: 'Extreme',
        image: 'extreme.png',
        imageMob: 'extreme-mob.png',
        title: 'Extreme Boss Difficulty:',
        text: 'Is Hard just not hard enough for you? Take on some of MapleStory\'s most iconic foes at a brand new ' +
            'difficulty tier that\'s a truly extreme challenge with even greater rewards!'
    }
]